import { number, string } from 'prop-types';
import React from 'react';
import { colors } from '@ajaibid/components';

const IconWithdrawl = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 4C2.5 3.44772 2.94772 3 3.5 3H21.5C22.0523 3 22.5 3.44772 22.5 4V11C22.5 11.5523 22.0523 12 21.5 12H18.5V21C18.5 21.5523 18.0523 22 17.5 22H7.5C6.94772 22 6.5 21.5523 6.5 21V12H3.5C2.94772 12 2.5 11.5523 2.5 11V4ZM18.5 10V8C19.0523 8 19.5 7.55228 19.5 7C19.5 6.44772 19.0523 6 18.5 6H6.5C5.94772 6 5.5 6.44772 5.5 7C5.5 7.55228 5.94772 8 6.5 8V10H4.5V5H20.5V10H18.5ZM13.5 11C13.5 10.4477 13.0523 10 12.5 10C11.9477 10 11.5 10.4477 11.5 11V15.0858L10.7071 14.2929C10.3166 13.9024 9.68342 13.9024 9.29289 14.2929C8.90237 14.6834 8.90237 15.3166 9.29289 15.7071L11.7929 18.2071C12.1834 18.5976 12.8166 18.5976 13.2071 18.2071L15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929C15.3166 13.9024 14.6834 13.9024 14.2929 14.2929L13.5 15.0858V11Z"
      fill={color}
    />
  </svg>
);

IconWithdrawl.propTypes = {
  color: string,
  size: number,
};

IconWithdrawl.defaultProps = {
  color: colors.AJAIB_BLUE_5,
  size: 24,
};

export default IconWithdrawl;
